/**
 * @fileoverview Global settings, options, etc.
 *
 * These are global settings and options used by all components.
 */

export const svgIconSpriteUrl = '/static/images/icons/lta-icons.svg';
